const NOTIFICATION_SETTINGS = {
  AUTO_TOP_UP_EMAIL: {
    key: 'top-up',
    label: 'Automatic Top-Up Payments',
  },
};

export default NOTIFICATION_SETTINGS;
